import React, { useState } from "react";
import Headline from "../../../../components/Typography/Headline";
import PropTypes from "prop-types";
import i18next from "i18next";
import {
    updateLocation,
    dispatchLocationChange,
} from "~/assets/js/Api/storeApi";
import AddressPopup from "~/assets/js/components/AddressPopup";
import { DELIVERY_TYPES } from "~/assets/js/components/AddressPopup/layout";

const DELIVERY_OPTIONS = {
    delivery: {
        icon: `${reactConfig.iconPath}/bicycle-new.svg`,
        title: i18next.t("home.banner.deliveryOptions.delivery.title"),
        content: i18next.t("home.banner.deliveryOptions.delivery.content"),
    },
    pickup: {
        icon: `${reactConfig.iconPath}/shop-new.svg`,
        title: i18next.t("home.banner.deliveryOptions.pickup.title"),
        content: i18next.t("home.banner.deliveryOptions.pickup.content"),
    },
};

export const DeliveryOptions = () => {
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [openTab, setOpenTab] = useState(DELIVERY_TYPES.DELIVERY);

    const submitData = async (
        area_update,
        location_update,
        address_update,
        shouldCloseOverlay = true
    ) => {
        const data = {
            area: area_update,
            location: location_update,
            address: address_update,
        };

        dispatchLocationChange(data);

        shouldCloseOverlay && setOverlayOpen(false);
        await updateLocation();
    };

    return (
        <>
            {overlayOpen && (
                <AddressPopup
                    setOpen={setOverlayOpen}
                    submitData={submitData}
                    openTab={openTab}
                />
            )}
            <div className="homepage-banner__options-container">
                <div className="container">
                    <div className="homepage-banner__delivery-options">
                        {Object.keys(DELIVERY_OPTIONS).map((option, idx) => (
                            <DeliveryOption
                                {...DELIVERY_OPTIONS[option]}
                                handleClick={() => {
                                    setOpenTab(option);
                                    setOverlayOpen(true);
                                }}
                                key={`delivery-option-${idx}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

const DeliveryOption = ({ icon, title, content, handleClick }) => (
    <div
        className="homepage-banner__delivery-options-item"
        onClick={handleClick}
    >
        <img
            alt={title}
            src={icon}
            className="homepage-banner__delivery-options-item-icon"
        />
        <div className="homepage-banner__delivery-options-item-info">
            <Headline size={6} resizable>
                {title}
            </Headline>
            <p>{content}</p>
        </div>
    </div>
);

DeliveryOption.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
};
